import React, { useEffect, useRef, useState } from "react";

const ROWS = [
  {
    sin: "Recepcionista responde WhatsApp todo el día — interrupciones constantes",
    // WEB.CL2 (11 Oct 2026): una disponibilidad no se promete; se dice "fuera de tu horario".
    con: "Sofi contesta los mensajes de WhatsApp, también fuera de tu horario",
  },
  {
    sin: "Citas perdidas cuando no contestan el teléfono o están en consulta",
    // TEN.4: decia "Cero citas perdidas" -- absoluto que nadie puede sostener (auditoria #19).
    con: "Sofi agenda aunque estés en consulta",
  },
  {
    sin: "Sin recordatorios → pacientes no se presentan → ingreso perdido",
    // TEN.4: decia "24h y 2h antes". El Job de recordatorios manda UNO, el dia anterior.
    con: "Recordatorio por WhatsApp el día anterior, en citas agendadas con al menos dos días de anticipación",
  },
  // TEN.4: se retiro la fila de "expediente digital": la propia landing dice, con razon, que
  // Surit NO sustituye el expediente clinico (auditoria #22).
  {
    sin: "No sabes cuántos pacientes llegaron ni cuánto ingresaste este mes",
    con: "Dashboard con métricas en tiempo real — decisiones con datos",
  },
];

function CheckIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      style={{ flexShrink: 0, marginTop: 1 }}
    >
      <circle cx="8" cy="8" r="8" fill="#D1FAE5" />
      <path
        d="M5 8l2.5 2.5L11 5.5"
        stroke="#059669"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function XIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      style={{ flexShrink: 0, marginTop: 1 }}
    >
      <circle cx="8" cy="8" r="8" fill="#FEE2E2" />
      <path
        d="M5.5 5.5l5 5M10.5 5.5l-5 5"
        stroke="#DC2626"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function BeforeAfter() {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="py-24 sm:py-28 bg-white" ref={sectionRef} id="comparativa">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-2xl mb-12">
          <p
            style={{
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: "0.18em",
              color: "#2563EB",
              textTransform: "uppercase",
              marginBottom: 10,
            }}
          >
            EL CAMBIO
          </p>
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">
            Tu clínica, antes y después de Sofi
          </h2>
        </div>

        {/* 2-col table */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 rounded-2xl overflow-hidden"
          style={{ border: "1px solid #E2E8F0", boxShadow: "0 8px 24px -12px rgba(15,23,42,.16)" }}
        >
          {/* SIN SOFI header */}
          <div
            style={{ background: "#FEE2E2", padding: "16px 24px", display: "flex", alignItems: "center", gap: 10 }}
          >
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: 9999,
                background: "#FCA5A5",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path
                  d="M2 2l10 10M12 2L2 12"
                  stroke="#DC2626"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <span style={{ fontWeight: 700, fontSize: 15, color: "#DC2626", letterSpacing: "0.02em" }}>
              SIN SOFI
            </span>
          </div>

          {/* CON SOFI header */}
          <div
            style={{ background: "#D1FAE5", padding: "16px 24px", display: "flex", alignItems: "center", gap: 10 }}
          >
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: 9999,
                background: "#6EE7B7",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path
                  d="M2 7l3.5 3.5L12 3"
                  stroke="#059669"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <span style={{ fontWeight: 700, fontSize: 15, color: "#059669", letterSpacing: "0.02em" }}>
              CON SOFI
            </span>
          </div>

          {/* Rows */}
          {ROWS.map((row, i) => {
            const isLast = i === ROWS.length - 1;
            const rowStyle = {
              opacity: visible ? 1 : 0,
              transform: visible ? "translateY(0)" : "translateY(16px)",
              transition: `opacity 0.45s ease ${i * 0.08}s, transform 0.45s ease ${i * 0.08}s`,
            };
            return (
              <React.Fragment key={i}>
                {/* SIN col */}
                <div
                  style={{
                    background: "#FFF5F5",
                    padding: "16px 24px",
                    borderTop: "1px solid #E2E8F0",
                    borderRight: "1px solid #E2E8F0",
                    borderBottom: isLast ? "none" : undefined,
                    ...rowStyle,
                  }}
                >
                  <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                    <XIcon />
                    <p style={{ fontSize: 14, color: "#334155", lineHeight: 1.55, margin: 0 }}>
                      {row.sin}
                    </p>
                  </div>
                </div>

                {/* CON col */}
                <div
                  style={{
                    background: "#F0FDF4",
                    padding: "16px 24px",
                    borderTop: "1px solid #E2E8F0",
                    borderBottom: isLast ? "none" : undefined,
                    ...rowStyle,
                    transitionDelay: `${i * 0.08 + 0.04}s`,
                  }}
                >
                  <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                    <CheckIcon />
                    <p style={{ fontSize: 14, color: "#334155", lineHeight: 1.55, margin: 0 }}>
                      {row.con}
                    </p>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </section>
  );
}
